.app {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  > main {
    flex: 1;
    min-height: 0;
    margin: 16px;
  }
  > footer {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 16px;
  }
}
